import { render, staticRenderFns } from "./Sidenav3.vue?vue&type=template&id=405058ec&scoped=true&"
import script from "./Sidenav3.vue?vue&type=script&lang=js&"
export * from "./Sidenav3.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav3.vue?vue&type=style&index=0&id=405058ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405058ec",
  null
  
)

export default component.exports